import {hydrateApp} from '@mfng/core/client/browser';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'tailwindcss/tailwind.css';

hydrateApp().catch(console.error);
